const bookmarkInput = document.getElementById("bookmarkInput"),
    bookmarkButton = document.getElementById("addBookmarkBtn"),
    bookmarkList = document.getElementById("bookmarkList");
// localStorage.clear();
let sessionBookmarksArray = !localStorage.bookmarks ? [] : JSON.parse(localStorage.bookmarks);
console.log(localStorage.bookmarks);
function bookmarksRefresh() {
    localStorage.bookmarks = JSON.stringify(sessionBookmarksArray);
    bookmarkList.innerHTML = "";
    sessionBookmarksArray.forEach(url => {
        bookmarkList.innerHTML += `<li><a href="${url}" target="_blank">${url}</a><button class="delete">X</button></li>`;
    });
}
bookmarksRefresh();
bookmarkButton.addEventListener("click", () => {
    const newUrl = bookmarkInput.value;
    if(newUrl === "") {
        return;
    }
    sessionBookmarksArray.push(newUrl);
    bookmarksRefresh();
});
bookmarkList.addEventListener("click", event => {
    const button = event.target;
    if(!button.classList.contains("delete")) {
        return;
    }
    const url = button.parentElement.querySelector("a").textContent;
    sessionBookmarksArray = sessionBookmarksArray.filter(element => element !== url);
    bookmarksRefresh();
});

const usernameInput = document.getElementById("username"),
    passwordInput = document.getElementById("password"),
    saveButton = document.getElementById("saveBtn");
if(localStorage.username !== undefined) {
    usernameInput.value = localStorage.username;
}
if(localStorage.password !== undefined) {
    passwordInput.value = localStorage.password;
}
saveButton.addEventListener("click", () => {
    localStorage.username = usernameInput.value;
    localStorage.password = passwordInput.value;
});